var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.5,8c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5,3.5-1.57,3.5-3.5-1.57-3.5-3.5-3.5Zm0,5c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5.673,1.5,1.5-.673,1.5-1.5,1.5Zm0,4c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5,3.5-1.57,3.5-3.5-1.57-3.5-3.5-3.5Zm0,5c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5.673,1.5,1.5-.673,1.5-1.5,1.5Zm-5.5-13c0,.552-.447,1-1,1H1c-.553,0-1-.448-1-1s.447-1,1-1h13c.553,0,1,.448,1,1ZM0,13c0-.552.447-1,1-1h10c.553,0,1,.448,1,1s-.447,1-1,1H1c-.553,0-1-.448-1-1Zm15,5c0,.552-.447,1-1,1H1c-.553,0-1-.448-1-1s.447-1,1-1h13c.553,0,1,.448,1,1Zm-3,4c0,.552-.447,1-1,1H1c-.553,0-1-.448-1-1s.447-1,1-1h10c.553,0,1,.448,1,1ZM3,6h18c1.654,0,3-1.346,3-3s-1.346-3-3-3H3C1.346,0,0,1.346,0,3s1.346,3,3,3Zm0-4h18c.552,0,1,.449,1,1s-.448,1-1,1H3c-.552,0-1-.449-1-1s.448-1,1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionAlt);
export default __webpack_public_path__ + "static/media/description-alt.a326c15e11948b60d9f1b483a6986402.svg";
export { ForwardRef as ReactComponent };